"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowFormatter = void 0;

var lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));

var lodash_isequal_1 = __importDefault(require("lodash.isequal"));

var FieldFormatter_1 = require("./FieldFormatter");

var types_1 = require("../types");

var RowFormatter = /*#__PURE__*/function () {
  function RowFormatter(formatterOptions) {
    _classCallCheck(this, RowFormatter);

    this.rowCount = 0;
    this.formatterOptions = formatterOptions;
    this.fieldFormatter = new FieldFormatter_1.FieldFormatter(formatterOptions);
    this.headers = formatterOptions.headers;
    this.shouldWriteHeaders = formatterOptions.shouldWriteHeaders;
    this.hasWrittenHeaders = false;

    if (this.headers !== null) {
      this.fieldFormatter.headers = this.headers;
    }

    if (formatterOptions.transform) {
      this.rowTransform = formatterOptions.transform;
    }
  }

  _createClass(RowFormatter, [{
    key: "rowTransform",
    set: function set(transformFunction) {
      if (!lodash_isfunction_1.default(transformFunction)) {
        throw new TypeError('The transform should be a function');
      }

      this._rowTransform = RowFormatter.createTransform(transformFunction);
    }
  }, {
    key: "format",
    value: function format(row, cb) {
      var _this = this;

      this.callTransformer(row, function (err, transformedRow) {
        if (err) {
          return cb(err);
        }

        if (!row) {
          return cb(null);
        }

        var rows = [];

        if (transformedRow) {
          var _this$checkHeaders = _this.checkHeaders(transformedRow),
              shouldFormatColumns = _this$checkHeaders.shouldFormatColumns,
              headers = _this$checkHeaders.headers;

          if (_this.shouldWriteHeaders && headers && !_this.hasWrittenHeaders) {
            rows.push(_this.formatColumns(headers, true));
            _this.hasWrittenHeaders = true;
          }

          if (shouldFormatColumns) {
            var columns = _this.gatherColumns(transformedRow);

            rows.push(_this.formatColumns(columns, false));
          }
        }

        return cb(null, rows);
      });
    }
  }, {
    key: "finish",
    value: function finish(cb) {
      var rows = []; // check if we should write headers and we didnt get any rows

      if (this.formatterOptions.alwaysWriteHeaders && this.rowCount === 0) {
        if (!this.headers) {
          return cb(new Error('`alwaysWriteHeaders` option is set to true but `headers` option not provided.'));
        }

        rows.push(this.formatColumns(this.headers, true));
      }

      if (this.formatterOptions.includeEndRowDelimiter) {
        rows.push(this.formatterOptions.rowDelimiter);
      }

      return cb(null, rows);
    } // check if we need to write header return true if we should also write a row
    // could be false if headers is true and the header row(first item) is passed in

  }, {
    key: "checkHeaders",
    value: function checkHeaders(row) {
      if (this.headers) {
        // either the headers were provided by the user or we have already gathered them.
        return {
          shouldFormatColumns: true,
          headers: this.headers
        };
      }

      var headers = RowFormatter.gatherHeaders(row);
      this.headers = headers;
      this.fieldFormatter.headers = headers;

      if (!this.shouldWriteHeaders) {
        // if we are not supposed to write the headers then
        // always format the columns
        return {
          shouldFormatColumns: true,
          headers: null
        };
      } // if the row is equal to headers dont format


      return {
        shouldFormatColumns: !lodash_isequal_1.default(headers, row),
        headers: headers
      };
    } // todo change this method to unknown[]

  }, {
    key: "gatherColumns",
    value: function gatherColumns(row) {
      if (this.headers === null) {
        throw new Error('Headers is currently null');
      }

      if (!Array.isArray(row)) {
        return this.headers.map(function (header) {
          return row[header];
        });
      }

      if (RowFormatter.isRowHashArray(row)) {
        return this.headers.map(function (header, i) {
          var col = row[i];

          if (col) {
            return col[1];
          }

          return '';
        });
      } // if its a one dimensional array and headers were not provided
      // then just return the row


      if (RowFormatter.isRowArray(row) && !this.shouldWriteHeaders) {
        return row;
      }

      return this.headers.map(function (header, i) {
        return row[i];
      });
    }
  }, {
    key: "callTransformer",
    value: function callTransformer(row, cb) {
      if (!this._rowTransform) {
        return cb(null, row);
      }

      return this._rowTransform(row, cb);
    }
  }, {
    key: "formatColumns",
    value: function formatColumns(columns, isHeadersRow) {
      var _this2 = this;

      var formattedCols = columns.map(function (field, i) {
        return _this2.fieldFormatter.format(field, i, isHeadersRow);
      }).join(this.formatterOptions.delimiter);
      var rowCount = this.rowCount;
      this.rowCount += 1;

      if (rowCount) {
        return [this.formatterOptions.rowDelimiter, formattedCols].join('');
      }

      return formattedCols;
    }
  }], [{
    key: "isRowHashArray",
    value: function isRowHashArray(row) {
      if (Array.isArray(row)) {
        return Array.isArray(row[0]) && row[0].length === 2;
      }

      return false;
    }
  }, {
    key: "isRowArray",
    value: function isRowArray(row) {
      return Array.isArray(row) && !this.isRowHashArray(row);
    } // get headers from a row item

  }, {
    key: "gatherHeaders",
    value: function gatherHeaders(row) {
      if (RowFormatter.isRowHashArray(row)) {
        // lets assume a multi-dimesional array with item 0 being the header
        return row.map(function (it) {
          return it[0];
        });
      }

      if (Array.isArray(row)) {
        return row;
      }

      return Object.keys(row);
    } // eslint-disable-next-line @typescript-eslint/no-shadow

  }, {
    key: "createTransform",
    value: function createTransform(transformFunction) {
      if (types_1.isSyncTransform(transformFunction)) {
        return function (row, cb) {
          var transformedRow = null;

          try {
            transformedRow = transformFunction(row);
          } catch (e) {
            return cb(e);
          }

          return cb(null, transformedRow);
        };
      }

      return function (row, cb) {
        transformFunction(row, cb);
      };
    }
  }]);

  return RowFormatter;
}();

exports.RowFormatter = RowFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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